import { useRef } from "react";
import { Carousel, Button } from "antd";
import "./styles.css";

const CarouselWithVideo = ({ videosWithTitles }) => {
  const carouselRef = useRef();
  // @ts-ignore
  const next = () => carouselRef.current.next();
  // @ts-ignore
  const prev = () => carouselRef.current.prev();

  return (
    <div className="carousel-container mx-auto w-full">
      <Carousel ref={carouselRef} className="carousel-wrapper">
        {videosWithTitles.map((videoWithTitle, index) => (
          <div key={index}>
            <div className="carousel-slide">
              {videoWithTitle.title && (
                <div className="carousel-text">
                  <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                    {videoWithTitle.title}
                  </h2>
                  <p className="text-lg lg:text-xl text-gray-600 font-medium mb-12">
                    {videoWithTitle.description}
                  </p>
                </div>
              )}
              <video
                className="carousel-video"
                autoPlay
                loop
                muted
                playsInline
                poster={videoWithTitle.thumbnailSrc}
              >
                <source src={videoWithTitle.videoSrc} />
              </video>
            </div>
          </div>
        ))}
      </Carousel>
      {videosWithTitles.length > 1 && (
        <div className="manual-controls">
          <Button onClick={prev} type="primary">
            prev
          </Button>
          <Button onClick={next} type="primary">
            next
          </Button>
        </div>
      )}
    </div>
  );
};

export default CarouselWithVideo;
